import { useState } from "react";
import { Maximize2, X } from "lucide-react";

const BOARDS = [
  {
    src: "/assets/flames/menu-board-1.jpg",
    title: "Burgers · Philly · Wings",
    sub: "Signature, Classic & Specialty burgers · 6-inch / 12-inch Philly · 31 wing flavors",
    testId: "menu-board-1",
  },
  {
    src: "/assets/flames/menu-board-2.jpg",
    title: "Specialties & Sides",
    sub: "Creamy Pastas · Quesadillas · Lock'd N Loaded Nachos · Seafood · Salads · Sides · Desserts",
    testId: "menu-board-2",
  },
];

export const PrintedMenu = () => {
  const [lightbox, setLightbox] = useState(null);
  return (
    <section
      data-testid="printed-menu"
      className="relative bg-[#0A0A0A] py-20 md:py-24 overflow-hidden border-t border-[#222]"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center">
          <div className="text-xs uppercase tracking-widest text-[#E60000] font-bold mb-3">The Boards</div>
          <h2 className="font-heading text-5xl sm:text-6xl md:text-7xl text-white">
            Straight Off The <span className="text-[#E60000]">Wall</span>
          </h2>
          <p className="text-white/60 max-w-xl mx-auto mt-4">
            The same menu boards hanging on the wall at Hillboyz. Tap any board to view full-size,
            then order through the <span className="text-[#E60000] font-bold">DoorDash</span> button
            at the bottom of the page.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
          {BOARDS.map((b) => (
            <button
              key={b.src}
              data-testid={b.testId}
              onClick={() => setLightbox(b.src)}
              className="group relative bg-[#1A1A1A] border-2 border-[#333] hover:border-[#E60000] transition-all duration-300 hover:-translate-y-1 overflow-hidden text-left"
            >
              <div className="relative aspect-[4/3] bg-black">
                <img
                  src={b.src}
                  alt={b.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 right-3 w-10 h-10 bg-black/70 backdrop-blur-sm flex items-center justify-center border border-white/20 opacity-0 group-hover:opacity-100 transition-opacity">
                  <Maximize2 className="w-4 h-4 text-white" strokeWidth={2.5} />
                </div>
              </div>
              <div className="p-5 bg-black/60 backdrop-blur-sm">
                <h3 className="font-heading text-2xl text-white">{b.title}</h3>
                <p className="text-xs uppercase tracking-widest text-[#E60000] font-bold mt-2">{b.sub}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {lightbox && (
        <div
          data-testid="lightbox"
          onClick={() => setLightbox(null)}
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 cursor-zoom-out"
        >
          <button
            data-testid="lightbox-close"
            onClick={(e) => { e.stopPropagation(); setLightbox(null); }}
            className="absolute top-4 right-4 w-12 h-12 bg-[#E60000] hover:bg-[#FF3333] text-white flex items-center justify-center"
          >
            <X className="w-6 h-6" strokeWidth={2.5} />
          </button>
          <img src={lightbox} alt="Full menu board" className="max-w-full max-h-full object-contain" />
        </div>
      )}
    </section>
  );
};
